import React from 'react';
import { Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import styles from 'assets/jss/material-dashboard-pro-react/components/dashboardSearchStyle';
import PageContainer from '../PageContainer/PageContainer';
import Search from 'components/Sidebar/subcomponents/Search';

// @ts-ignore
const useStyles = makeStyles(styles);

const SearchBar: React.FC = ({ children }) => {
	const classes = useStyles();

	return (
		<section className={classes.searchSection}>
			<PageContainer>
				<Grid
					container
					className={classes.userAndSearch}
					direction="row"
					justify="space-between"
					alignItems="center"
				>
					<Grid item sm={12} md={6} lg={8} className={classes.userContainer}>
						{children}
					</Grid>
					<Grid item sm={12} md={6} lg={4} className={classes.searchContainer}>
						<Search />
					</Grid>
				</Grid>
			</PageContainer>
		</section>
	);
};

export default SearchBar;
